// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"BackHeader_titleContainer_301iZ","btnBack":"BackHeader_btnBack_2coZQ"};